<template>
  <AccountViewBase :account="account" :loading="loading" :error="error">
    <div class="container-fluid content-type-3">
      <div class="container">
        <SettingsTitle />
        <AccountDetailsSection />
        <component
          v-if="isProspectPro && notificationSettingsComponent"
          :is="notificationSettingsComponent"
        />
        <component
          v-if="isProspectPro && trackerSettingsComponent"
          :is="trackerSettingsComponent"
        />
        <component
          v-if="isProspectPro && apiSettingsComponent"
          :is="apiSettingsComponent"
          :account="account"
        />
      </div>
    </div>
  </AccountViewBase>
</template>

<script>
  import { defineAsyncComponent } from 'vue';
  import AccountViewBase from '@/views/account/AccountViewBase';
  import i18nViewMixin from '@/mixins/i18nViewMixin';
  import accountMixin from '@/mixins/accountMixin';
  import SettingsTitle from '@/components/account/settings/SettingsTitle';
  import AccountDetailsSection from '@/components/account/settings/AccountDetailsSettings';
  import { scrollToTop } from '@/utils/scroll';

  const isProspectPro = process.env.VUE_APP_TYPE === 'prospectpro' || process.env.VUE_APP_PRODUCT_PREFIX === 'pp';

  export default {
    name: 'AccountSettingsView',
    components: {
      AccountViewBase,
      SettingsTitle,
      AccountDetailsSection,
    },
    mixins: [i18nViewMixin, accountMixin],
    data() {
      return {
        seo_title: 'views.account_settings.seo_title',
        isProspectPro
      };
    },
    computed: {
        notificationSettingsComponent() {
            return isProspectPro
            ? defineAsyncComponent(() =>
                import(
                    /* webpackChunkName: "PpNotificationSettings" */ '@/components/account/settings/AccountNotificationSettings'
                )
                )
            : null;
        },
        trackerSettingsComponent() {
            return isProspectPro
            ? defineAsyncComponent(() =>
                import(
                    /* webpackChunkName: "PpTrackerSettings" */ '@/components/account/settings/AccountTrackerSettings'
                )
                )
            : null;
        },
        apiSettingsComponent() {
            return isProspectPro
            ? defineAsyncComponent(() =>
                import(
                    /* webpackChunkName: "PpApiSettings" */ '@/components/account/settings/AccountApiSettings'
                )
                )
            : null;
        }
    },
    mounted() {
      scrollToTop();
    }
  };
</script>